/**
 * Reproducción del AUDIO MODELO de la batería (la locución humana del estímulo
 * que el niño debe repetir/denominar).
 *
 * CONSISTENCIA CLÍNICA (master §1 regla 6): el modelo es una locución HUMANA
 * pregrabada (word_media), idéntica para todos los niños. NO hay TTS de relleno:
 * un ítem sin audio activo simplemente no suena (el botón de repetir se oculta),
 * porque un modelo sintetizado por dispositivo rompería la comparabilidad del
 * estímulo entre evaluaciones.
 */

export interface Locucion {
  /** URL firmada del audio a reproducir; null → no suena (sin TTS de relleno). */
  audioRef: string | null;
}

/** Elemento en reproducción (para poder detenerlo al cambiar de ítem/paso). */
let actual: HTMLAudioElement | null = null;

/**
 * Reproduce una locución y resuelve cuando termina. Nunca rechaza: si no hay
 * audio (audioRef null) o el elemento falla, resuelve de inmediato para no
 * bloquear la máquina de estados (el guion avanza igual; el adulto puede repetir
 * cuando hay botón).
 */
export function reproducir(l: Locucion): Promise<void> {
  detener();
  if (!l.audioRef || typeof Audio === "undefined") return Promise.resolve();
  return new Promise<void>((resolve) => {
    const a = new Audio(l.audioRef!);
    actual = a;
    let listo = false;
    const terminar = () => {
      if (listo) return;
      listo = true;
      if (actual === a) actual = null;
      resolve();
    };
    a.onended = terminar;
    a.onerror = terminar;
    void a.play().catch(terminar);
  });
}

export function detener(): void {
  if (actual) {
    try {
      actual.pause();
    } catch {
      // ignorar
    }
    actual = null;
  }
}
